var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rate-limit-container" },
    [
      _c(
        "el-alert",
        { staticClass: "rule-tip", attrs: { type: "info", closable: false } },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "rule-content" }, [
              _c("p", [
                _c("b", [
                  _vm._v(
                    "请求处理链路：SQL注入检测 → 黑名单检查 → URL规则匹配 → 全局规则兜底"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("1. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【SQL注入检测】"),
                ]),
                _vm._v(
                  "拦截请求参数和JSON Body中的SQL关键字（union/select/drop/exec等），命中自动封禁IP并返回400"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("2. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【黑名单检查】"),
                ]),
                _vm._v(
                  "IP黑名单面向所有请求，USER黑名单仅限已登录用户，命中返回403"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("3. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【URL规则】"),
                ]),
                _vm._v(
                  "匹配成功则对该接口做总量限流，超阈值返回429、不封禁、窗口过后自动恢复；多条规则按优先级升序前缀匹配，命中即停"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("4. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【全局规则】"),
                ]),
                _vm._v(
                  "未匹配URL规则时生效，已登录用户按userId+IP限流，未登录按IP限流，触发后自动封禁；阈值设为0即不限制"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("5. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【计数方式】"),
                ]),
                _vm._v(
                  "基于Redis固定窗口计数，窗口内累计请求数，超过阈值返回429；默认不限制，仅当显式配置后才生效"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("6. "),
                _c("b", { staticStyle: { color: "#e6a23c" } }, [
                  _vm._v("【缓存容灾】"),
                ]),
                _vm._v(
                  "全局配置仅允许一条；增删改操作自动刷新Redis缓存，也可手动刷新；Redis异常时自动放行，不阻塞业务"
                ),
              ]),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.queryParams, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "类型" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "全部", clearable: "" },
                  model: {
                    value: _vm.queryParams.configType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "configType", $$v)
                    },
                    expression: "queryParams.configType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "全局", value: "GLOBAL" },
                  }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "URL", value: "URL" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "配置名称", clearable: "" },
                model: {
                  value: _vm.queryParams.configName,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "configName", $$v)
                  },
                  expression: "queryParams.configName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", icon: "el-icon-refresh" },
                  on: { click: _vm.handleRefreshCache },
                },
                [_vm._v("刷新缓存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.list,
            border: "",
            size: "small",
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "configName",
              label: "配置名称",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "configType",
              label: "类型",
              width: "70",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.configType === "GLOBAL"
                              ? "danger"
                              : "warning",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.configType === "GLOBAL" ? "全局" : "URL"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "urlPattern",
              label: "URL匹配",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.urlPattern
                      ? _c("span", [_vm._v(_vm._s(scope.row.urlPattern))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ipMaxRequests",
              label: "IP阈值",
              width: "85",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.configType === "GLOBAL"
                      ? _c("span", [_vm._v(_vm._s(scope.row.ipMaxRequests))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "userMaxRequests",
              label: "用户阈值",
              width: "85",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.configType === "GLOBAL"
                      ? _c("span", [_vm._v(_vm._s(scope.row.userMaxRequests))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "totalMaxRequests",
              label: "总量阈值",
              width: "85",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.configType === "URL" && scope.row.totalMaxRequests
                      ? _c("span", [_vm._v(_vm._s(scope.row.totalMaxRequests))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "windowSeconds",
              label: "窗口(秒)",
              width: "85",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "优先级", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.configType === "URL"
                      ? _c("span", [_vm._v(_vm._s(scope.row.priority))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "70", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.enabled === 1 ? "success" : "info",
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.enabled === 1 ? "启用" : "禁用") +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "160",
              align: "center",
              formatter: _vm.formatDateTime,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "140",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#f56c6c" },
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("el-pagination", {
            staticStyle: { "margin-top": "15px", "text-align": "right" },
            attrs: {
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [10, 20, 50, 100],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "480px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "配置名称", prop: "configName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如：全局默认、下单接口限流" },
                    model: {
                      value: _vm.form.configName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "configName", $$v)
                      },
                      expression: "form.configName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "配置类型", prop: "configType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.isEdit },
                      model: {
                        value: _vm.form.configType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "configType", $$v)
                        },
                        expression: "form.configType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "GLOBAL" } }, [
                        _vm._v("全局默认"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "URL" } }, [
                        _vm._v("URL规则"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.configType === "URL"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "URL匹配前缀", prop: "urlPattern" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "如：/api/order/submitOrder" },
                        model: {
                          value: _vm.form.urlPattern,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "urlPattern", $$v)
                          },
                          expression: "form.urlPattern",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.configType === "GLOBAL"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "IP限流阈值", prop: "ipMaxRequests" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: 100000,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.ipMaxRequests,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ipMaxRequests", $$v)
                          },
                          expression: "form.ipMaxRequests",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-tip" }, [
                        _vm._v("0=不限，次/窗口"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.configType === "GLOBAL"
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "用户限流阈值", prop: "userMaxRequests" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: 100000,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.userMaxRequests,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userMaxRequests", $$v)
                          },
                          expression: "form.userMaxRequests",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-tip" }, [
                        _vm._v("0=不限，次/窗口"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.configType === "URL"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "总量限流阈值" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: 1000000,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.totalMaxRequests,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalMaxRequests", $$v)
                          },
                          expression: "form.totalMaxRequests",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-tip" }, [
                        _vm._v("0=不限，次/窗口"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时间窗口", prop: "windowSeconds" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 86400, "controls-position": "right" },
                    model: {
                      value: _vm.form.windowSeconds,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "windowSeconds", $$v)
                      },
                      expression: "form.windowSeconds",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-tip" }, [_vm._v("秒")]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.configType === "URL"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "优先级", prop: "priority" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          max: 9999,
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.form.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "priority", $$v)
                          },
                          expression: "form.priority",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-tip" }, [
                        _vm._v("越小越优先匹配"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.enabled,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "enabled", $$v)
                        },
                        expression: "form.enabled",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }